/**
 * fancyboxGallery Component
 *
 * @file slider.js
 */

import $ from "jquery";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";


const fancyboxGallery = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const defaultFancybox = () => {
    Fancybox.bind('[data-fancybox]', {
      // Custom options for all galleries
    }); 
  };

  const init = () => {
    defaultFancybox();
  };

  return {
    init,
  };
})();

export default fancyboxGallery;